module.exports = __webpack_public_path__ + "media/images/nutri_ads/restilen_300x250_1-38de592e4b835da19bd9bd8ee13f7665.jpg";